import React from 'react'
import { useEffect } from "react";
import Header from "components/Headers/Header.js";
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, CardFooter, Button} from "reactstrap";
import { useTranslation } from 'react-i18next';
import {Link} from 'react-router-dom'

function FotoInsuranceUser() {
////////////
  const { t, i18n } = useTranslation();  

  useEffect(() => {
      const storedLanguage = localStorage.getItem('selectedLanguageAFS');
      if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
      }
  }, [i18n]);
  ////////////

  return (
    <div>
      <Header/>
      <Container className="mt--15" fluid>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
            <Card className='shadow'>
              <CardHeader>
                <h3>{t('Coming soon')}</h3>
              </CardHeader>
              <CardBody>
                <>
                  <Spinner
                    color="primary"
                    type="grow"
                  >
                    Loading...
                  </Spinner>
                  <Spinner
                    color="success"
                    type="grow"
                  >
                    Loading...
                  </Spinner>
                  <Spinner
                    color="danger"
                    type="grow"
                  >
                    Loading...
                  </Spinner>
                  <Spinner
                    color="warning"
                    type="grow"
                  >
                    Loading...
                  </Spinner>
                  <Spinner
                    color="info"
                    type="grow"
                  >
                    Loading...
                  </Spinner>
                  <Spinner
                    color="light"
                    type="grow"
                  >
                    Loading...
                  </Spinner>
                  <Spinner
                    color="dark"
                    type="grow"
                  >
                    Loading...
                  </Spinner>
                </>
              </CardBody>
              <CardFooter>
                <Link to="/">
                  <Button color='primary'>
                    {t('Go back')} <i className="fas fa-rotate-left"></i>
                  </Button>
                </Link>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default FotoInsuranceUser
